import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { MenuItem, MenuList, Typography } from '@mui/material';
import PlaceHolder from '../../common/PlaceHolder';
const renderTree = (category, depth, editData) => (_jsxs(_Fragment, { children: [_jsx(MenuItem, { sx: { pl: depth * 2 }, children: _jsx(Link, { to: `cat/${category.slug || category.id}`, onClick: (ev) => editData && editData.preNavigationHook(`cat/${category.slug || category.id}`, ev), children: _jsx(Typography, { component: "div", variant: depth === 0 ? 'subtitle1' : 'subtitle2', sx: {
                        color: '#ffffff',
                        display: 'flex',
                        alignItems: 'center', /* align vertical */
                    }, children: category.name }) }) }, category.id), category.subCategories?.map((subCat) => (renderTree(subCat, depth + 1, editData)))] }));
const getRootCategory = (categoryId, portal, display) => {
    let category;
    if (display === 'root') {
        [category] = portal.categories;
    }
    else if (display === 'top') {
        const path = portal.getCategoryPath(categoryId);
        [, category] = path;
    }
    else if (display === 'subs') {
        category = portal.getCategory(categoryId);
    }
    return category;
};
/**
 * Choices for how this works:
 * 1) Always show the root category
 * 2) Show the subcategories of the selected category
 * 3) Show the top level category of the selected category
 * 4) Show specific category
 *
 * @param param0
 * @returns
 */
const SubCategoryNav = ({ display, categoryId, context, editData, configId, }) => {
    const category = getRootCategory(categoryId, context.portal, display);
    const isEmpty = () => (!categoryId || !category);
    if (isEmpty() && editData && editData.activeConfigId !== configId) {
        return _jsx(PlaceHolder, { placeHolderName: "Configure SubCategory Nav" });
    }
    return (_jsx(MenuList, { "aria-label": "course sections tree view", sx: {
            width: '100%',
            height: '100%',
            background: (theme) => (theme.palette.subNav.main),
            color: (theme) => (theme.palette.subNav.text.primary),
            padding: '16px',
        }, children: category?.subCategories?.map((subCategory) => renderTree(subCategory, 0, editData)) }));
};
SubCategoryNav.defaultProps = {};
SubCategoryNav.meta = {
    group: 'portal',
    name: 'Sub Category Nav',
    description: 'Shows sub categories global',
    props: [
        {
            key: 'display',
            name: 'Display',
            type: 'selector',
            menuItems: [
                { value: 'root', label: 'Root Category', description: 'Show top-level categories' },
                { value: 'top', label: 'Top Level', description: 'Display the subcategories of the top-level category of the category' },
                { value: 'subs', label: 'Sub-categories', description: 'Display the subcategories of the category' },
            ],
        },
        {
            key: 'categoryId',
            name: 'Category',
            type: 'category',
            description: 'Category or group to display items from',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'SubCategoryNav',
        props: {
            display: 'root',
            categoryId: '@categoryId',
        },
    },
};
export default SubCategoryNav;
//# sourceMappingURL=SubCategoryNav.js.map